import { CHAIN_ID } from './chains'
import { chainTokens } from './tokens'
import { PoolCategory, PoolChainConfig } from './types'

// const serializedTokens = serializeTokens()

const boosters: PoolChainConfig = 
{
  [CHAIN_ID.FANTOM_TESTNET]: [
 {
    sousId: 1,
    stakingToken: chainTokens.lum,
    earningToken: chainTokens.magicLum,
    contractAddress: {
      4002: '0xC5a3B90f05bbb6517aBbE637eCdC744FcC38dC19',
    },
    poolCategory: PoolCategory.CORE_NFT_RESTRICTED,
    harvest: true,
    tokenPerSecond: '0',
    sortOrder: 1,
    isFinished: false,
    nft: {
       4002: '0xA7B988485957C15faB89aeB8602B66A1502aA30d'
    }
  },  
  ]
}
export default boosters
